import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { App as AntdApp, ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import type { ReactNode } from 'react';

import { OverlayKeyboardBoundary } from '../shared/overlay-keyboard-boundary.js';

export interface ApplicationProvidersProps {
  readonly children: ReactNode;
  readonly queryClient: QueryClient;
}

export function ApplicationProviders({ children, queryClient }: ApplicationProvidersProps) {
  return (
    <ConfigProvider
      button={{ classNames: { root: 'app-accessible-button' } }}
      drawer={{ focusable: { focusTriggerAfterClose: true, trap: true } }}
      locale={zhCN}
      modal={{ focusable: { focusTriggerAfterClose: true, trap: true } }}
      theme={{
        cssVar: { key: 'badminton' },
        token: {
          colorLink: '#0958d9',
          colorLinkHover: '#003eb3',
          colorLinkActive: '#002c8c',
        },
        components: {
          Button: {
            colorPrimary: '#0958d9',
            colorPrimaryHover: '#003eb3',
            colorPrimaryActive: '#002c8c',
            colorError: '#cf1322',
            colorErrorHover: '#a8071a',
            colorErrorActive: '#820014',
            primaryColor: '#ffffff',
            dangerColor: '#ffffff',
            opacityLoading: 1,
          },
          Menu: { darkItemSelectedBg: '#0958d9' },
          Form: { colorError: '#cf1322' },
          Tabs: { itemSelectedColor: '#0958d9' },
        },
      }}
    >
      <AntdApp>
        <OverlayKeyboardBoundary />
        <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
      </AntdApp>
    </ConfigProvider>
  );
}
